export default __webpack_public_path__ + "static/media/while-logo.bffbf8ad.png";